import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { LanguagesService } from '../../../services/language.service';
import { BaseService } from '../../../services/base.service';
import { ValidationService } from 'src/app/services/validation.service';


@Component({
  selector: 'app-profession',
  templateUrl: './profession.component.html',

})
export class ProfessionComponent implements OnInit {
  @Input() form: FormGroup = null;
  myProfession: FormArray;
  professionList;
  subjectList = new Array();
  public required = new Array<any>();

  constructor(public languagesService: LanguagesService,
    public baseService: BaseService,
    private formBuilder: FormBuilder) { }
  i = 0;
  ngOnInit(): void {

    this.form.addControl('myProfession', this.formBuilder.array([this.createMyProfession()]));
    this.myProfession = this.form.get('myProfession') as FormArray;

    let frm = this.myProfession.controls[0] as FormGroup;
    let ff = frm.controls;
    ff.subject.disable();
  }

  addMyProfessionItem() {
    this.myProfession.push(this.createMyProfession());
    let frm = this.myProfession.controls[this.myProfession.controls.length - 1] as FormGroup;
    let ff = frm.controls;
    ff.subject.disable();

  }
  createMyProfession() {

    return this.formBuilder.group({
      subjectField: new FormControl('', []),
      subject: new FormControl('', [])
    });

  }
  removeMyProfessionItem(i) {
    this.myProfession.removeAt(i);
    this.subjectList.splice(i,1)
    this.required[i] = false;
  }

  public get f() {
    return this.form.controls;
  }

  public get f2() {
    return this.myProfession.controls as Array<FormGroup>;
  }


  onselect(i) {
    this.required[i] = true;
    ValidationService.SetValidators(this.f2[i].controls.subject);
    console.log(this.myProfession.controls['subjectField'], "fffffff");
    let frm = this.myProfession.controls[i] as FormGroup;
    let ff = frm.controls; 
    ff.subject.enable();
    let tchum = this.form.controls.myProfession.value[i].subjectField
    this.subjectList[i] = this.baseService.Tchummikz.filter(t => t.TCHUM == tchum);
    ff.subject.setValue(null);
  }


  onSubmit() {
    this.professionList = new Array<any>();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false;
    }


    //אם יש יותר משורה אחת בדיקה שאין שורות חופפות!
    for (let i = 0; i < this.myProfession.length; i++) {

      let error; let j = i;

      for (; j < this.myProfession.length; j++) {
        if (i != j) {

          error = ValidationService.compareProfession(this.f2[i].controls, this.f2[j].controls)
          if (error) {
            this.f2[j].controls.subjectField.setErrors(error);
            return;
          }

        }
      }
      if (this.form.controls.myProfession.value[i].subjectField != "" && (i == j)) {
        let proff = {
          Uid: this.baseService.LoggedUser.MEZAHE_ZAFUY_INTERNET,
          KodProfessionField: this.form.controls.myProfession.value[i].subjectField,
          TeurProfessionField: this.baseService.ThumTaasuka.find(f => f.KOD == [Number(this.form.controls.myProfession.value[i].subjectField)]).TEUR,
          KodProfession: this.form.controls.myProfession.value[i].subject,
          TeurProfession: this.baseService.Tchummikz.find(f => f.KOD == [Number(this.form.controls.myProfession.value[i].subject)]).TEUR
        }
        this.professionList.push(proff);
      }
    }


  }
}
